export default __webpack_public_path__ + "static/loans-to-go-new-banner-4d3418df1b20a868280639366a898384.webp";